import React, { useMemo, useState } from "react";
import "../PayProTerms.css";

const terms = [
  [`Introduction`, `These Terms & Conditions (“Terms”) govern your registration, access to and use of the PayPro consumer mobile application (“PayPro App” or “App”) and the services available through it.

The App is operated by PayPro Private Limited (“PayPro”, “we”, “us” or “our”).

By creating an account, selecting “I Agree”, or using the PayPro App, you confirm that you have read and agreed to these Terms and acknowledge the PayPro Consumer Mobile Application Privacy Policy.

If you do not agree with these Terms, you should not register for or use the App.

Certain services may be provided, processed or supported by banks, Electronic Money Institutions (“EMIs”), Payment System Operators/Payment Service Providers (“PSOs/PSPs”), payment processors, merchants, billers or other authorised partners. Additional terms may apply to such services.`],
  [`PayPro App Services`, `Depending on availability and your eligibility, the PayPro App may allow you to:

register and manage your account;

view and pay bills and invoices;

make digital or QR payments;

make card-based payments;

use wallet-related services;

transfer funds;

manage beneficiaries;

purchase mobile airtime or bundles;

view transaction history and receipts; and

use other payment services introduced by PayPro.

Some services may require additional verification, KYC, activation or acceptance of separate terms.`],
  [`Eligibility and Registration`, `To use the PayPro App, you must:

be legally eligible to use the relevant service;

provide accurate and current information;

have a valid mobile number;

complete required verification; and

use the App only for lawful purposes.

Certain financial services may require a valid CNIC, KYC or additional identity verification.

You must not:

register using another person’s identity without authority;

provide false or misleading information;

impersonate another person;

create an account for fraudulent or unlawful purposes; or

attempt to bypass PayPro’s verification or security controls.

PayPro may request additional verification where required for security, fraud prevention or regulatory purposes.`],
  [`Account Security`, `You are responsible for taking reasonable steps to protect your PayPro account.

You should:

keep your password and PIN confidential;

never share an OTP;

secure your mobile device;

review transaction notifications; and

immediately report suspicious or unauthorised activity.

PayPro will never legitimately request your password, PIN or OTP through an unsolicited call, SMS, email, WhatsApp message or social-media message.

If your phone, SIM or account credentials are lost or compromised, you should contact PayPro as soon as possible.`],
  [`Payments and Transactions`, `When you confirm a transaction through the App, you authorise PayPro and the relevant payment provider to process it.

Before confirming a payment, you should check:

merchant, biller or beneficiary;

invoice or consumer number;

transaction amount;

payment method;

applicable charges; and

other transaction details.

Once a transaction has been submitted, it may not always be possible to cancel it.

A transaction is considered successful only when confirmation is received from the relevant payment system, bank, wallet, merchant or service provider.

You should retain the transaction reference for any future enquiry or complaint.`],
  [`Bills and Invoices`, `PayPro may allow you to view and pay bills or invoices issued by participating merchants, schools, businesses and other billers.

The underlying bill information may be supplied by the relevant biller.

You should confirm that the biller, invoice number, amount and other details are correct before payment.

PayPro may facilitate payment but is not necessarily responsible for the underlying goods, services or invoice amount.

Disputes regarding the underlying bill, product or service may need to be raised directly with the relevant merchant or biller.`],
  [`Wallet and Partner Services`, `Some wallet, transfer or other financial services available through the App may be provided by regulated partner institutions.

Where applicable:

separate KYC or activation may be required;

transaction or balance limits may apply;

additional terms may apply;

the partner may maintain or safeguard the funds; and

the partner may conduct compliance or fraud checks.

PayPro’s inclusion of a service in the App does not necessarily mean PayPro itself is the bank, EMI or legal custodian of funds for that service.`],
  [`Fees and Transaction Limits`, `Some PayPro services may be free, while others may carry fees or charges.

Where a charge applies, it should be displayed before you confirm the transaction.

Charges may be imposed by PayPro or by a bank, wallet provider, payment network, merchant, biller or other service provider.

Transactions may also be subject to:

minimum or maximum amounts;

daily or monthly limits;

wallet or account limits;

regulatory limits; and

security or fraud-prevention controls.

Applicable limits may depend on your account status and verification level.`],
  [`Failed, Pending and Reversed Transactions`, `A transaction may fail, remain pending or be delayed because of:

insufficient funds;

incorrect information;

bank or payment-network downtime;

merchant or biller issues;

internet or telecommunications failure;

transaction limits;

security checks; or

technical problems.

If funds are debited but the payment is unsuccessful, a reversal may be processed after confirmation from the relevant payment provider.

Reversal timelines may differ depending on the bank, payment method or network involved.

If a transaction remains unresolved, you should contact PayPro using the relevant transaction reference.`],
  [`Refunds and Disputes`, `Refunds and reversals may depend on the relevant merchant, biller, bank, payment processor or payment network.

Where a dispute concerns the goods or services purchased, such as:

non-delivery;

incorrect goods;

service quality; or

merchant cancellation,

you may need to contact the merchant directly.

Where the issue concerns transaction processing, duplicate debit, incorrect payment status or another PayPro-related payment issue, you may contact PayPro customer support.`],
  [`Unauthorised Transactions and Fraud`, `If you notice a transaction you do not recognise, you should report it immediately.

PayPro or the relevant financial institution may:

temporarily restrict the account;

request additional verification;

investigate the transaction;

block a payment method; or

take other reasonable security measures.

Responsibility for an unauthorised transaction will depend on the circumstances, applicable regulations and the rules of the relevant payment provider.

Nothing in these Terms removes any consumer right or protection that cannot lawfully be excluded.`],
  [`Your Responsibilities`, `You agree to:

provide accurate information;

protect your account credentials;

review transaction details before confirming;

use the App only for lawful purposes;

comply with applicable transaction limits; and

report suspicious activity promptly.

You must not use the PayPro App to:

commit fraud;

launder money;

conduct unlawful transactions;

gain unauthorised access to another person’s account;

interfere with App security;

bypass KYC or transaction controls;

introduce malware; or

misuse PayPro’s systems.`],
  [`Account Restriction or Closure`, `PayPro may restrict, suspend or close an account where reasonably necessary, including where:

required by law or regulation;

identity or KYC requirements are not satisfied;

fraudulent or suspicious activity is detected;

false information has been provided;

security has been compromised; or

these Terms have been materially violated.

You may also request closure of your account.

Closing the PayPro App account may not automatically close a separate wallet, bank account or financial product maintained by a partner institution.

PayPro may retain certain transaction, KYC or regulatory records after account closure where legally required.`],
  [`Service Availability`, `PayPro aims to provide reliable access to the App, but uninterrupted service cannot always be guaranteed.

Services may be temporarily unavailable due to:

maintenance;

technical issues;

network or telecommunications problems;

bank or payment-network downtime;

cybersecurity events;

third-party service interruptions; or

regulatory requirements.

PayPro will take reasonable steps to restore affected services.`],
  [`Third-Party Services`, `The App may use or provide access to services operated by third parties, including banks, merchants, billers, wallet providers and payment processors.

Those services may be governed by their own:

terms and conditions;

privacy policies;

fees;

refund rules; and

service limitations.

PayPro is responsible for its own services but does not control independent third-party products or services.`],
  [`Privacy`, `Your personal information will be handled in accordance with the PayPro Consumer Mobile Application Privacy Policy.

The Privacy Policy explains:

what information PayPro collects;

how it is used;

how it may be shared;

how it is protected;

how long it may be retained; and

your privacy choices.`],
  [`Communications`, `PayPro may communicate with you through:

push notifications;

SMS;

email;

telephone;

WhatsApp; or

in-App messages.

These communications may include:

OTPs;

transaction updates;

security alerts;

service notices;

complaint updates;

changes to these Terms; and

promotional communications where permitted.

You are responsible for keeping your registered contact information updated.`],
  [`Intellectual Property`, `The PayPro App, software, branding, logos, content and design are owned by or licensed to PayPro.

You may use the App only for its intended personal and consumer purposes.

You must not, without proper authority:

copy or commercially exploit the App;

modify or distribute its software;

misuse PayPro’s name or branding;

interfere with its security; or

attempt to obtain its source code through unauthorised methods.`],
  [`Liability`, `PayPro will take reasonable care in providing its services.

To the extent permitted by law, PayPro will not be responsible for losses caused solely by circumstances outside its reasonable control, including:

bank or payment-network failures;

telecommunications or internet outages;

merchant or biller system errors;

incorrect information entered by the user;

independent third-party services; or

events beyond PayPro’s reasonable control.

PayPro is not responsible for the quality, suitability or delivery of goods or services provided by independent merchants.

Nothing in these Terms limits any liability or consumer protection that cannot legally be excluded.`],
  [`Complaints and Customer Support`, `If you have a problem with your account or transaction, you may contact PayPro customer support.

For transaction complaints, you should provide information such as:

registered mobile number;

transaction reference;

transaction date;

amount;

merchant or biller; and

details of the problem.

Where a service is provided by a partner financial institution, PayPro may coordinate with or direct the complaint to that provider where appropriate.

PayPro Contact Details

PayPro Private Limited

Address: Suite 302, Plot 1C, Tariq Center, Tariq Road, Karachi, Pakistan
Email: info@paypro.com.pk
Phone: [Insert Official Consumer Support Number]`],
  [`Changes to These Terms`, `PayPro may update these Terms because of:

changes to App features or services;

regulatory or legal requirements;

changes in fees;

new partner arrangements; or

security or operational requirements.

Where required, users will be informed of material changes before they take effect.

If renewed acceptance is required, you may be asked to review and accept the updated Terms before continuing to use the relevant service.`],
  [`Governing Law`, `These Terms are governed by the applicable laws of the Islamic Republic of Pakistan.

Any dispute will be handled through the applicable complaint, regulatory or legal processes available under Pakistani law.

Nothing in these Terms prevents you from approaching a competent regulator, complaint forum or court where permitted.`],
  [`Acceptance`, `By selecting “I Agree”, creating an account or otherwise accepting these Terms, you confirm that:

you have been given access to these Terms;

you understand your responsibilities as a PayPro App user;

you agree to comply with these Terms; and

you acknowledge the PayPro Consumer Mobile Application Privacy Policy.

PayPro may maintain a record of your acceptance, including the date, time and version of the Terms accepted.

PayPro Private Limited
Consumer Mobile Application Terms & Conditions
Version 1.0`]
];

const slug = (text) => text.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export default function TermsAndCondtion() {
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return terms;
    return terms.filter(([title, body]) =>
      `${title} ${body}`.toLowerCase().includes(q)
    );
  }, [query]);

  return (
    <div className="page">
     

      <section className="hero">
        <div className="eyebrow">PAYPRO CONSUMER APP</div>
        <h1>Terms & Conditions<br /><strong>for Consumers</strong></h1>
        <p>These Terms govern your registration, access to and use of the PayPro consumer mobile application and the services available through it.</p>
      </section>

      <div className="layout">
        <aside className="sidebar">
          <div className="sidebar-title">Terms & Conditions</div>
          <nav>
            {terms.map(([sectionTitle], i) => (
              <a className="link" href={`#${slug(sectionTitle)}`} key={sectionTitle}>
                <span>{String(i + 1).padStart(2, "0")}</span>
                <span>{sectionTitle}</span>
              </a>
            ))}
          </nav>
        </aside>

        <main>
          <div className="search">
            <span className="search-icon">⌕</span>
            <input
              value={query}
              onChange={e => setQuery(e.target.value)}
              placeholder="Search this document..."
            />
            {query && <button onClick={() => setQuery("")}>×</button>}
          </div>

          {filtered.map(([sectionTitle, body]) => (
            <section className="section" id={slug(sectionTitle)} key={sectionTitle}>
              <div className="number">
                {String(terms.findIndex(s => s[0] === sectionTitle) + 1).padStart(2, "0")}
              </div>
              <div>
                <h2>{sectionTitle}</h2>
                {body.split("\n\n").map((paragraph, i) => (
                  <div className="paragraph" key={i}>
                    {paragraph.split("\n").map((line, j) =>
                      line.startsWith("•") ? (
                        <div className="bullet" key={j}>
                          <b>•</b><span>{line.slice(1).trim()}</span>
                        </div>
                      ) : <div key={j}>{line}</div>
                    )}
                  </div>
                ))}
              </div>
            </section>
          ))}

          {filtered.length === 0 && <div className="empty">No matching content found.</div>}

          <footer className="footer">
            <strong>PayPro Private Limited</strong>
            <span>Version 1.0</span>
            <span>Last Updated: {new Date().toLocaleDateString()}</span>
          </footer>
        </main>
      </div>
    </div>
  );
}
